<template>
    <!-- sidebar -->
    <ul @click="closePortalMenu" class="nav d-block flex-column shop-sidebar">
        <li class="nav-item">
            <router-link :to="{ name: 'dashboard' }" class="nav-link py-3"><i class="fas fa-tachometer-alt"></i> Dashboard</router-link>
        </li>
        <li class="nav-item" v-if="this.user">
            <router-link :to="{ name: 'profile' }" class="nav-link py-3"><i class="fas fa-user"></i> Account</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'items' }" class="nav-link py-3"><i class="fas fa-camera"></i> Items</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'wallet' }" class="nav-link py-3"><i class="fas fa-wallet"></i> Wallet</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'on-sale' }" class="nav-link py-3"><i class="fas fa-tags"></i> On-Sale</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'donations' }" class="nav-link py-3"><i class="fas fa-gifts"></i> Donations</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'promotions' }" class="nav-link py-3"><i class="fas fa-fire"></i> Promotions</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'main-categories' }" class="nav-link py-3"><i class="fas fa-layer-group"></i> Categories</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'shipping-fees' }" class="nav-link py-3"><i class="fas fa-shipping-fast"></i> Shipping-Fees</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'activities' }" class="nav-link py-3"><i class="fas fa-history"></i> Activities</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'shoppers' }" class="nav-link py-3"><i class="fas fa-users"></i> Shoppers</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'performance' }" class="nav-link py-3"><i class="fas fa-chart-line"></i> Performance</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'shop-settings' }" class="nav-link py-3"><i class="fas fa-tools"></i> Settings</router-link>
        </li>
        <li class="nav-item text-danger" @click="exitShopFxn">
            <a class="nav-link py-3" href="javascript:void(0);"><i class="fas fa-lock"></i> Exit Shop</a>
        </li>
    </ul>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Sidebar",
    methods: {
        ...mapActions(['exitShop']),
        exitShopFxn() {
            this.exitShop()
            .then(() => {
                this.passcode = ''
                this.$router.push({
                    name: 'profile'
                }).catch((e) => {})
            }).catch((e) => {
                this.msg = "Sorry, we are unable to exit your shop at this time. Try again!"
                this.passcode = ''
            })
        },
        closePortalMenu() {
            this.$emit("emitHidePortalMenu")
        }
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>